export default __webpack_public_path__ + "favicons/android-chrome-512x512.png";